module.exports = __webpack_public_path__ + "img/手势识别--多种手势--比心gif.dba96638.gif";